import * as angular from "angular";

class outputsConfig {

    constructor () {
        return {OUTPUT_DATE_FORMAT : 'MMM D, YYYY  h:mm A'}
    }
};

export default outputsConfig;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/config/config.ts
 **/